import React, { useState } from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "../App.css";
import SummaryApi from "../common/index";
import { useNavigate } from "react-router-dom"; // for navigation
import Cookies from "js-cookie"; // to handle cookies
import CustomDialog from './CustomDialog';

function Form() {
  // State for all the form fields
  const [studentName, setStudentName] = useState("");
  const [studentNumber, setStudentNumber] = useState("");
  const [parentName, setParentName] = useState("");
  const [parentNumber, setParentNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [isError, setIsError] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    address: "",
  });
  const navigate = useNavigate(); // useNavigate for navigation

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [isValidPhone, setIsValidPhone] = useState(true);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length <= 10) {
      setStudentNumber(value);
    }
  };

  const validatePhoneNumber = () => {
    const cleanedNumber = studentNumber.replace(/[^0-9]/g, '');
    if (cleanedNumber.length !== 10) {
      setIsValidPhone(false);
      //alert("Please enter exactly 10 digits for the phone number.");
      return false;
    }
    setIsValidPhone(true);
    return true;
  };

  // Mark handleSubmit as async
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure the phone numbers are exactly 10 digits
    if (studentNumber.replace(/[^0-9]/g, '').length !== 10) {
      return;
    }

    if (!selectedCourse) {
      setIsError(true); // Show error if no course is selected
      return;
    } else {
      setIsError(false); // Clear error if a course is selected
    }

    const payload = {
      student_name: studentName,
      mobile_number: studentNumber.replace(/[^0-9]/g, ""),
      parent_name: parentName,
      email: email,
      address: address,
      course: selectedCourse,
    };

    // alert(`Our Team will Contact You Soon.`);
     // Show success dialog
     setDialogMessage("Our Team will Contact You Soon.");
     setIsDialogVisible(true);

    // Reset form fields after submission
    setStudentName("");
    setStudentNumber("");
    setParentName("");
    setParentNumber("");
    setEmail("");
    setAddress("");
    setSelectedCourse("");

    try {
      const response = await fetch(SummaryApi.createContact.url, {
        method: SummaryApi.createContact.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (data.student_id) {
        Cookies.set("student_id", data.student_id, { expires: 7 });
        const message = `
          *Enrollment Form Details:*
          *Student Name:* ${studentName}
          *Student Number:* ${studentNumber}
          *Email:* ${email}
          *Address:* ${address}
          *Selected Course:* ${selectedCourse}
        `;
        const encodedMessage = encodeURIComponent(message);
        const whatsappNumber = "+918919311981";
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
        window.location.href = whatsappURL;
        navigate("/");
      }
    } catch (error) {
      console.error("Error during registration:", error);
    }
  };

  const closeDialog = () => {
    setIsDialogVisible(false);
  };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 p-4">
     {isDialogVisible && <CustomDialog  message={dialogMessage} onClose={closeDialog} />}
      <form
        className="w-full max-w-4xl bg-white p-8 rounded-lg shadow-xl border border-gray-200"
        onSubmit={handleSubmit}
      >
        <h2 className="text-3xl font-extrabold mb-6 text-gray-800 text-center">
          Contact Form
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Student Name */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Student Name <span className="text-red-500"></span>
            </label>
            <input
              type="text"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              placeholder="Student Name"
              className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
            />
          </div>

          {/* Student Number */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Phone Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              value={studentNumber}
              onChange={handlePhoneChange}
              onBlur={validatePhoneNumber}

              style={{
                width: "100%",
                borderRadius: "0.5rem",
                border: `1px solid ${isValidPhone ? "#d1d5db" : "#f87171"}`,
                padding: "10px",
              }}
              placeholder="Enter phone number"
              required
              maxLength={10}
            />
            {!isValidPhone && (
              <p style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                Please enter exactly 10 digits for the phone number.
              </p>
            )}
          </div>

          {/* Parent Name */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Father/Mother Name <span className="text-red-500"></span>
            </label>
            <input
              type="text"
              value={parentName}
              onChange={(e) => setParentName(e.target.value)}
              placeholder="Father/Mother Name"
              className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Email <span className="text-red-500"></span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your Email"
              className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
            />
          </div>

          {/* Address */}
          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Address <span className="text-red-500"></span>
            </label>
            <textarea
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Enter your address"
              className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
              rows="4"
            />
          </div>

          {/* Course Selection */}
          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Select Course <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
              value={selectedCourse}
              onChange={(e) => setSelectedCourse(e.target.value)}
              // required
            >
              <option value="" disabled>
                -- Select a Course --
              </option>
              <option value="ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING">
                ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING
              </option>
              <option value="COMPUTER SCIENCE & ENGINEERING">
                COMPUTER SCIENCE & ENGINEERING
              </option>
              <option value="ELECTRONICS & COMMUNICATION ENGINEERING">
                ELECTRONICS & COMMUNICATION ENGINEERING
              </option>
              <option value="CIVIL ENGINEERING">CIVIL ENGINEERING</option>
              <option value="ELECTRICAL & ELECTRONICS ENGINEERING">
                ELECTRICAL & ELECTRONICS ENGINEERING
              </option>
              <option value="MECHANICAL ENGINEERING">MECHANICAL ENGINEERING</option>
              <option value="CLOUD COMPUTING & BIG DATA">
                CLOUD COMPUTING & BIG DATA
              </option>
            </select>
            {isError && (
              <p className="text-red-500 text-sm mt-1">Please select course</p>
            )}
          </div>

        </div>

        {/* Submit Button */}
        <div className="mt-4">
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-blue-700 transition duration-300 shadow-md"
          >
            Submit
          </button>
        </div>
      </form>
      
    </div>
  );
}

export default Form;
